import {useMutation, useQuery, useQueryClient} from "react-query";
import {deleteTodo, fetchTaskById, fetchTodo, handleSaveTask, handleUpdateTask} from "../api/taskApi";

export function useTaskById(token, id) {
    return useQuery({
        queryKey: ['todo', id],
        queryFn: () => fetchTaskById(id, token),
        enabled: !!token && !!id,
    });
}

export function useTask (token) {
    return useQuery({
        queryKey: ['todo'],
        queryFn: () => fetchTodo(token),
        enabled: !!token,
    });
}

export function useDeleteTask(token) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id) => deleteTodo(id, token),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['todo']});
        },
    });
}

export function useCreateTask(token) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (text) => handleSaveTask(text, token),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['todo']});
        },
    });
}

export function useUpdateTask(token) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({id, task}) => handleUpdateTask(id, task, token),
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({queryKey: ['todo']});
            queryClient.invalidateQueries({queryKey: ['todo', variables.id]});
        },
    });
}
